import Vue from 'vue'
import App from './App.vue'
import router from './router'
import smoothscroll from 'smoothscroll-polyfill'


smoothscroll.polyfill();

Vue.config.productionTip = false

// Pagination
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)


// Loading Overlay
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);


/* Vue Apollo */
import VueApollo from 'vue-apollo'
import { apolloProvider } from './utils/apollo'
Vue.use(VueApollo)


/* Layouts */
import DefaultLayout from './layouts/default'
Vue.component('default-layout', DefaultLayout)
import SelectorLayout from './layouts/selector'
Vue.component('selector-layout', SelectorLayout)

new Vue({
  router,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')


const files = require.context('./components/', true, /\.vue/i)

files.keys().map(key => {
  const component = key.split('/').pop().split('.')[0]
  // With Lazy Loading
  Vue.component(component, () => import(`./components${key.replace('./','/')}`))

  // Or without Lazy Loading
  // Vue.component(component, files(key).default)
})

var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);



import './styles/global.scss';
